"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Epsilon Image Dimensions
 */
var EpsilonImageDimensions = /** @class */ (function () {
    /**
     * Control constructor
     *
     * @param control
     */
    function EpsilonImageDimensions(control) {
        /**
         * Control instance
         * @type {null}
         */
        this.control = null;
        /**
         * Related controls
         * @type {null}
         */
        this.linkedControl = null;
        /**
         * Value to be saved in the database
         * @type {{}}
         */
        this.value = {
            width: null,
            height: null,
            ratio: true,
            linked_control: '',
        };
        /**
         * Calculated ratio for the loaded image
         */
        this.imageSizes = {
            width: 0,
            height: 0,
        };
        /**
         * Has image
         */
        this.hasImage = false;
        /**
         * Expose api to this instance
         */
        this.api = wp.customize;
        this.control = control;
        this.value.linked_control = control.params.linkedControl;
        this.mergeValues();
        this.linkedControl = this.api.control(control.params.linkedControl);
        this.setLinkedControlSpecs();
        this.init();
    }
    /**
     * Init function
     */
    EpsilonImageDimensions.prototype.init = function () {
        var _this = this;
        /**
         * Handle events
         */
        this.handleInputChanges();
        this.handleAspectRatio();
        /**
         * Bind event on the linked control change
         */
        this.linkedControl.setting.bind('change', function () {
            _this.linkedControlChanged();
        });
    };
    /**
     * Merge already set values
     */
    EpsilonImageDimensions.prototype.mergeValues = function () {
        return jQuery.extend(this.value, this.control.params.value);
    };
    /**
     * Verify the linked control specs and update our object
     */
    EpsilonImageDimensions.prototype.setLinkedControlSpecs = function () {
        this.imageSizes = {
            width: 0,
            height: 0,
        };
        this.hasImage = typeof this.linkedControl.params.attachment !== 'undefined';
        if (this.hasImage) {
            this.imageSizes = {
                width: this.linkedControl.params.attachment.width,
                height: this.linkedControl.params.attachment.height,
            };
        }
    };
    /**
     * Toggle aspect ratio
     */
    EpsilonImageDimensions.prototype.handleAspectRatio = function () {
        var _this = this;
        this.control.container.find('input[type="checkbox"]').on('change', function (event) {
            _this.value.ratio = jQuery(event.target).prop('checked');
            _this.saveData();
        });
    };
    /**
     * Handles changes inside the
     */
    EpsilonImageDimensions.prototype.handleInputChanges = function () {
        var _this = this;
        this.control.container.find('input[type="text"]').on('keyup', _.debounce(function (element) {
            var key = jQuery(element.target).attr('data-type'), val = jQuery(element.target).val();
            if (typeof key === 'undefined') {
                return;
            }
            if (typeof val === 'string') {
                val = parseInt(val);
            }
            _this.setDimension(key, val);
        }, 200));
    };
    /**
     * Linked control change should update inputs
     */
    EpsilonImageDimensions.prototype.linkedControlChanged = function () {
        if (typeof this.linkedControl.params.attachment === 'undefined') {
            return;
        }
        this.setLinkedControlSpecs();
        this.control.container.find('input[data-type="width"]').val(this.linkedControl.params.attachment.width).change();
        this.control.container.find('input[data-type="height"]').val(this.linkedControl.params.attachment.height).change();
    };
    /**
     * Sets dimension for the image
     *
     * @param {String} key
     * @param {Number} val
     */
    EpsilonImageDimensions.prototype.setDimension = function (key, val) {
        if (typeof key === 'undefined') {
            return;
        }
        if (!this.value.hasOwnProperty(key)) {
            return;
        }
        this.value[key] = val;
        if (this.value.ratio) {
            this.calculateRatio(key);
        }
        this.saveData();
    };
    /**
     * Calculates ratio
     */
    EpsilonImageDimensions.prototype.calculateRatio = function (key) {
        switch (key) {
            case 'width':
                // height = user width * original height / original width
                this.value.height = Math.ceil(this.value.width * this.linkedControl.params.attachment.height / this.linkedControl.params.attachment.width);
                this.control.container.find('input[data-type="height"]').val(this.value.height);
                break;
            default:
                // width = user height * original width / original height
                this.value.width = Math.ceil(this.value.height * this.linkedControl.params.attachment.width / this.linkedControl.params.attachment.height);
                this.control.container.find('input[data-type="width"]').val(this.value.width);
                break;
        }
    };
    /**
     * Saves data in the customizer
     */
    EpsilonImageDimensions.prototype.saveData = function () {
        this.control.setting(JSON.stringify(this.value));
    };
    return EpsilonImageDimensions;
}());
exports.EpsilonImageDimensions = EpsilonImageDimensions;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/controls/image-dimensions.ts
// module id = 40
// module chunks = 0